import { render } from "./locked_overlay.vue?vue&type=template&id=639d97c0&scoped=true&lang=pug"
import script from "./locked_overlay.vue?vue&type=script&lang=js"
export * from "./locked_overlay.vue?vue&type=script&lang=js"

import "./locked_overlay.vue?vue&type=style&index=0&id=639d97c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639d97c0"]])

export default __exports__